import { render } from "./EditAddress.vue?vue&type=template&id=2e5fb023&scoped=true"
import script from "./EditAddress.vue?vue&type=script&lang=js"
export * from "./EditAddress.vue?vue&type=script&lang=js"

import "./EditAddress.vue?vue&type=style&index=0&id=2e5fb023&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5fb023"]])

export default __exports__